import { SxProps, Typography } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import {
	subtitleDpBestOfferSX,
	titleDpBestOfferSX,
} from '@/components/blocks/DpLibrary/DpBestOffer/style/typography';
import { imageDpBestOfferSX } from '@/components/blocks/DpLibrary/DpBestOffer/style/image';
import { Linkable } from '@/components/blocks/Linkable';
import { combineSX } from '@/utils/combineSX';

export const DpBestOffer = ({
	title,
	subtitle,
	image,
	href,
	sximage,
	sxtitle,
	sxsubtitle,
	alt,
	loading,
	priority,
}: {
	title: string;
	subtitle: string;
	image: string;
	href?: string;
	sximage?: SxProps;
	sxtitle?: SxProps;
	sxsubtitle?: SxProps;
	alt?: string;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
}) => (
	<Linkable href={href}>
		<Img
			alt={alt}
			src={image}
			sx={combineSX([imageDpBestOfferSX, ...(Array.isArray(sximage) ? sximage : [sximage])])}
			loading={loading}
			priority={priority}
		/>
		<Typography
			component="h3"
			sx={combineSX([titleDpBestOfferSX, ...(Array.isArray(sxtitle) ? sxtitle : [sxtitle])])}
		>
			{title}
		</Typography>
		<Typography
			sx={combineSX([
				subtitleDpBestOfferSX,
				...(Array.isArray(sxsubtitle) ? sxsubtitle : [sxsubtitle]),
			])}
		>
			{subtitle}
		</Typography>
	</Linkable>
);
